import { useState } from 'react'
import { trackGTM } from '@helpers/core/trackGTM'

const TARGET_SCROLL_POINTS = { 25: false, 50: false, 75: false, 90: false }

export const useTrackGTMScrollPercentage = (percentage: number) => {
  const [targetScrollPointsState, setTargetScrollPointsState] =
    useState(TARGET_SCROLL_POINTS)

  // if the reached scroll point is one of the target points and it hasn't already been reached
  // trigger GTM tracking event & mark scroll point as reached
  const handleScroll = (percentage: number) => {
    if (
      Object.keys(targetScrollPointsState).includes(percentage.toString()) &&
      targetScrollPointsState[
        percentage as keyof typeof targetScrollPointsState
      ] === false
    ) {
      // eslint-disable-next-line camelcase
      trackGTM({ event: 'scroll_depth', scroll_percentage: percentage })
      setTargetScrollPointsState({
        ...targetScrollPointsState,
        [percentage]: true,
      })
    }
  }

  if (percentage >= 20 && percentage <= 30) {
    handleScroll(25)
  } else if (percentage > 45 && percentage <= 55) {
    handleScroll(50)
  } else if (percentage > 70 && percentage <= 80) {
    handleScroll(75)
  } else if (percentage > 85) {
    handleScroll(90)
  }
}
